<template>
        <div>
                <el-dialog
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        top="60px"
                        :visible.sync="dialogShow"
                        width="230mm"
                        :modal-append-to-body="false">
                        <template slot="title">
                                <div class="avue-crud__dialog__header">
                                        <span class="el-dialog__title">
                                                打 印
                                        </span>
                                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                        
                                </div>
                                <el-divider></el-divider>
                        </template>
                        <div :style="'max-height:'+dialogBodyHight+'px;overflow:scroll;'" >
                                <div style="width:210mm;height:297mm;" id="print20211206">
                                        <h2>{{form.$projectId}}工单</h2>
                                        <p>打印时间: {{dayjs().format('YYYY-MM-DD HH:mm:ss')}}</p>
                                        <div class="row">
                                                <div class="col-label">
                                                        工单类型
                                                </div>
                                                <div class="col-value">
                                                        {{form.moduleTypeName}}-{{form.subModuleName}}
                                                </div>
                                                <div class="col-label">
                                                        工单编号
                                                </div>
                                                <div class="col-value">
                                                        {{form.code}}
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">
                                                        需求人
                                                </div>
                                                <div class="col-value">
                                                        {{form.requireManName}}
                                                </div>
                                                <div class="col-label">
                                                        电话
                                                </div>
                                                <div class="col-value">
                                                        {{form.requireMainPhone}}
                                                </div>
                                                <div class="col-label">
                                                        部门
                                                </div>
                                                <div class="col-value">
                                                        {{form.requireDeptName}}
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">服务地点</div>
                                                <div class="col-value">
                                                        {{form.areaName}}
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">
                                                        期望到场
                                                </div>
                                                <div class="col-value">
                                                        {{form.expectStartTime}}
                                                </div>
                                                <div class="col-label">
                                                        需求来源
                                                </div>
                                                <div class="col-value">
                                                        {{form.sourceName}}
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label" style="height:28mm;line-height:28mm;">描述</div>
                                                <div class="col-value" style="line-height:21px;">
                                                        {{form.description}}
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label" style="height: calc(58mm + 3px);line-height:58mm;">设备信息</div>
                                                <div class="col-value">
                                                        <div class="row">
                                                                <div class="col-label">设备名称</div>
                                                                <div class="col-value">{{businessData.deviceName}}</div>
                                                                <div class="col-label">设备编号</div>
                                                                <div class="col-value">{{businessData.code}}</div>
                                                                
                                                        </div>
                                                        <div class="row">
                                                                <div class="col-label">所属部门</div>
                                                                <div class="col-value">{{businessData.deptName}}</div>
                                                        </div>
                                                        <div class="row">
                                                                <div class="col-label">存放位置</div>
                                                                <div class="col-value">{{businessData.areaName}}</div>
                                                        </div>
                                                        <div class="row">
                                                                <div class="col-label" style="height:28mm;line-height:28mm;">备注</div>
                                                                <div class="col-value" style="line-height:21px;">{{businessData.deviceDescription}}</div>
                                                        </div>
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">
                                                        服务人员
                                                </div>
                                                <div class="col-value">

                                                </div>
                                                <div class="col-label">
                                                        电话
                                                </div>
                                                <div class="col-value">
                                                        
                                                </div>
                                                <div class="col-label">
                                                        班组
                                                </div>
                                                <div class="col-value ">
                                                        
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label" style="height:40mm;line-height:40mm;">现场记录</div>
                                                <div class="col-value "></div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label" style="height:40mm;line-height:40mm;">服务项目</div>
                                                <div class="col-value "></div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label" style="height:40mm;line-height:40mm;">耗材明细</div>
                                                <div class="col-value "></div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">维修金额</div>
                                                <div class="col-value"></div>
                                                <div class="col-label">服务工时</div>
                                                <div class="col-value " ></div>
                                        </div>
                                        <div class="row">
                                                <div class="col-label">签名</div>
                                                <div class="col-value"></div>
                                                <div class="col-label">完成日期</div>
                                                <div class="col-value " ></div>
                                        </div>
                                </div>
                                
                        </div>
                        <template slot="footer" >
                                <el-divider></el-divider>
                                <div>
                                        <el-button icon="el-icon-printer" type="primary" style="margin-right:10px" size="small" @click="formSubmit(false)">打 印</el-button>
                                </div>
                        </template>
                </el-dialog>
        </div>
</template>
<style scoped>
.row{
        display: flex;
        width: 100%;
        border-top: 1px solid #333;
    
}
.col-label{
        border-left: 1px solid #333;
        text-align: center;
        flex-grow: 0;
        flex-shrink: 0;
        height: 10mm;
        line-height: 10mm;
        width: 80px;
}
.col-value{
        text-align: left;
        border-left: 1px solid #333;
        flex-grow: 1;
        flex-shrink: 1;
        line-height: 10mm;
        padding: 0 8px;
}
#print20211206 > div:nth-child(8) > div.col-value{
         padding: 0;
}
.row .col-value:last-child{
        border-right:1px solid #333;
}
.row:last-child{
        border-bottom:1px solid #333;
}
.col-value>.row:last-child{
        border-bottom:none;
}
.col-value .row:first-child{
        border-top: none;
}
.col-value .row .col-label:first-child{
        border-left: none;
}
.col-value .row .col-value:last-child{
        border-right: none;
}

p{
       text-align: right; 
}
h2{
        text-align: center;
}
</style>
<script>
import dayjs from "dayjs"
export default {
 
        data(){
                return{
                        dayjs:dayjs,
                        dialogBodyHight:0,
                        dialogFull:false,
                        form:{},
                        businessData:{},
                        treeFormAreaData:[],//懒加载区域树 --报修表单中
                        data:{},
                        cheackedPeople:[],
                        userList:[],
                        groupList:[],
                        dialogShow:false,
                        orderId:'',
                }
        },
                mounted(){
                        this.dialogFull = false;
                        let bodyHight = document.body.clientHeight;

                        this.dialogBodyHight = bodyHight - 320;

                },
        methods:{
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        formSubmit(){
         
            this.$confirm('确认打印吗？','提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then((_) => {
                        Print('#print20211206', {
                                onStart: function () {
                                console.log('onStart', new Date())
                                },
                                onEnd: function () {
                                console.log('onEnd', new Date())
                                }
                        })
                })
                .catch((_) => {});
        },
        openDialog(data){
                console.log(data)
                this.dialogShow = true;
                this.form = data;
                this.businessData = data.businessData;
            
        },
       
    }
}
</script>
